import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
    // Optional: send error to a logging service
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm">
          <Paper elevation={6} sx={{ p: 4, mt: 10, textAlign: 'center', borderRadius: 3 }}>
            <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />
            <Typography variant="h4" mt={2} gutterBottom>
              Something went wrong.
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              Please try reloading the page or contact support if the problem persists.
            </Typography>
            <Button variant="contained" style={{backgroundColor: '#12132b', color:'#d1d1e6'}} onClick={this.handleReload}>
              Reload Page
            </Button>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
